import React, { useState } from 'react';

function PasteModal({ open, onClose, onSave }) {
  const [text, setText] = useState('');
  const [language, setLanguage] = useState('plaintext');
  const [isPublic, setIsPublic] = useState(false);
  const [burnAfterRead, setBurnAfterRead] = useState(false);
  
  // Expiration State
  const [expirationMode, setExpirationMode] = useState('never'); // never, 10m, 1h, 1d, 1w, custom
  const [customExpiration, setCustomExpiration] = useState('');

  if (!open) return null;

  const handleSave = () => {
    let expiresAt = null;
    const now = new Date();
    
    switch (expirationMode) {
      case '10m':
        now.setMinutes(now.getMinutes() + 10);
        expiresAt = now.toISOString();
        break;
      case '1h':
        now.setHours(now.getHours() + 1);
        expiresAt = now.toISOString();
        break;
      case '1d':
        now.setDate(now.getDate() + 1);
        expiresAt = now.toISOString();
        break;
      case '1w':
        now.setDate(now.getDate() + 7);
        expiresAt = now.toISOString();
        break;
      case 'custom':
        if (customExpiration) {
          expiresAt = new Date(customExpiration).toISOString();
        }
        break;
      default:
        expiresAt = null;
    }
    
    onSave(text, language, { is_public: true, burn_after_read: burnAfterRead, expires_at: expiresAt });
    
    // Reset
    setText('');
    setLanguage('plaintext');
    setBurnAfterRead(false);
    setExpirationMode('never');
    setCustomExpiration('');
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '800px' }}>
        <h2 style={{ marginTop: 0 }}>New Paste</h2>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: 16 }}>
          <div>
            <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Language</label>
            <select 
              value={language} 
              onChange={e => setLanguage(e.target.value)} 
              className="input"
              style={{ width: '100%' }}
            >
              <option value="plaintext">Plain Text</option>
              <option value="javascript">JavaScript</option>
              <option value="python">Python</option>
              <option value="json">JSON</option>
              <option value="html">HTML</option>
              <option value="css">CSS</option>
            </select>
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Expiration</label>
            <select 
              value={expirationMode} 
              onChange={e => setExpirationMode(e.target.value)} 
              className="input"
              style={{ width: '100%' }}
            >
              <option value="never">Never</option>
              <option value="10m">10 Minutes</option>
              <option value="1h">1 Hour</option>
              <option value="1d">1 Day</option>
              <option value="1w">1 Week</option>
              <option value="custom">Custom Date/Time</option>
            </select>
            {expirationMode === 'custom' && (
              <input 
                type="datetime-local" 
                value={customExpiration} 
                onChange={e => setCustomExpiration(e.target.value)} 
                className="input"
                style={{ width: '100%', marginTop: 8 }}
              />
            )}
          </div>
        </div>
        
        <div style={{ display: 'flex', gap: '2rem', marginBottom: 16 }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
            <input 
              type="checkbox" 
              checked={burnAfterRead} 
              onChange={e => setBurnAfterRead(e.target.checked)} 
            />
            Burn After Read
          </label>
        </div>

        <textarea
          value={text}
          onChange={e => setText(e.target.value)}
          rows={10}
          className="input"
          style={{ width: '100%', fontFamily: 'monospace', fontSize: 14, marginBottom: 16, resize: 'vertical' }}
          placeholder="Paste your code or text here..."
        />
        <div className="modal-actions">
          <button onClick={onClose} className="btn btn-secondary">Cancel</button>
          <button onClick={handleSave} className="btn btn-primary">Save</button>
        </div>
      </div>
    </div>
  );
}

export default PasteModal;
